export default __webpack_public_path__ + "static/media/icon-incorrect-map.f67bc3ee.svg";